import * as React from 'react';
import { useState, useEffect, useRef, useContext } from 'react';
import { FilterWrapper, TableWrapper } from '../UI/styledConstants';
import Pagination from '../Pagination/Pagination';
import { clickOutside, getCurrentDate, isEmpty, pdfData } from '../../utils/common';
import LocalLoader from '../UI/Loader/LocalLoader';
import { CSVLink } from 'react-csv';
import Bbpslogo from '../../assets/images/BbpsLogo.png';
import bbpsLogo2 from '../../assets/images/Bbpslogo3.svg';
import { useNavigate } from 'react-router-dom';
import { bbpsCheckTransactionStatus, bbpsComplainList, bbpsTransactionList } from '../../utils/api';
import { GlobleContaxt } from '../../Context/GlobleContaxt';
import Loader from '../UI/Loader/Loader';
import BbpsTransactionReceipt from './BbpsTransactionReceipt';
import { ServiceBoxWrapper } from '../ServicesBox/style';
import Back from '../UIbox/Back';


const BbpsTransactionHistory = () => {
	const { userDetails } = useContext(GlobleContaxt);
	const [downloadLoader, setDownloadLoader] = useState('');

	const [filter, setFilter] = useState({
		fromDate: '',
		toDate: '',
		txnId: '',
		refId: '',
		status: '',
		pageNo: 0,
		pageSize: 10,
	});

	const [loading, setLoading] = useState(false);

	const [complaintHistory, setComplaintHistory] = useState([]);
	const [paging_data, setPagingData] = useState(null);
	const [totalElement, setTotalElement] = useState('');
	const [csvData, setCsvData] = useState([]);
	const [transactionDaital, setTransactionDaital] = useState({});

	const popupRef = useRef(null)

	const link = useRef(null);
	const navigate = useNavigate();
	const { setAlert } = useContext(GlobleContaxt);
	const getTransactionHistory = async (key = '', page = 0) => {
		let fromDate = '';
		let toDate = '';

		if (!isEmpty(filter.fromDate)) {
			const parts = filter.fromDate.split('-');
			const formattedDate = parts[0] + '-' + parts[1] + '-' + parts[2];
			fromDate = formattedDate;
		}
		if (!isEmpty(filter.toDate)) {
			const parts = filter.toDate.split('-');
			const formattedDate = parts[0] + '-' + parts[1] + '-' + parts[2];
			toDate = formattedDate;
		}

		const payload = {
			toDate: toDate,
			fromDate: fromDate,
			txnId: filter.txnId,
			refId: '',
			refTxnId: filter.refId,
			status: filter.status,
			complaintStatus: '',
			userUuid: userDetails?.uuid,
			pagination: {
				pageNo: filter.pageNo,
				pageSize: filter.pageSize,
			},
		};
console.log("payload",payload)
		if (key === 'csv' || key === 'pdf') {
			if (key === 'csv') {
				setDownloadLoader('csv');
			} else {
				setDownloadLoader('pdf');
			}
			payload.pagination.pageSize = totalElement;
		} else if (key !== '') {
			payload.pagination.pageNo = 0;
			setLoading(true);
		} else {
			setLoading(true);
		}

		if (key === 'pagination') {
			payload.pagination.pageNo = page;
		}

		if(key === "refresh"){
			payload.toDate ="";
			payload.fromDate ="";
			payload.txnId ="";
			payload.refTxnId ="";
			payload.status ="";
			
			setFilter({fromDate: '',
				toDate: '',
				txnId: '',
				refId: '',
				status: '',
				pageNo: 0,
				pageSize: 10,})
		}

		bbpsTransactionList(payload).then((resp) => {
			setLoading(false);
			setDownloadLoader('');
			if (resp?.success) {
				if (key !== 'csv' && key !== 'pdf') {
					setComplaintHistory(resp?.data?.content);
					setTotalElement(resp?.data?.totalElements);
					setPagingData({
						number: resp?.data?.number,
						totalPages: resp?.data?.totalPages,
					});
				} else if (key === 'csv') {
					setCsvData(resp?.data?.content);

					const csvlink = link.current;
					csvlink.link.click();
				} else if (key === 'pdf') {
					setCsvData(resp?.data?.content);
					pdfDownload(resp?.data?.content);
				}
			} else {
				if (resp?.errorCodeList.length > 0 && !isEmpty(resp?.errorCodeList[0])) {
					setAlert({ type: 'error', msg: resp?.errorCodeList[0] });
				} else {
					setAlert({ type: 'error', msg: resp?.msg });
				}
				setComplaintHistory([]);
			}
		});
	};

	const filterChangeHandler = (e) => {
		const { name, value } = e.target;
		if (name === 'toDate') {
			if (isEmpty(filter.fromDate)) {
				return false;
			}
		}
		setFilter({ ...filter, pageNo: 0, [name]: value });
	};

	useEffect(() => {
		getTransactionHistory('');
	}, []);

	const headers = [
		{ label: 'Mobile No.', key: 'mobile' },
		{ label: 'Reference Transaction Id', key: 'refTransactionId' },
		{ label: 'Transaction Id', key: 'transactionId' },
		{ label: 'Transaction Date', key: 'createdDate' },
		{ label: 'TransactionId Amount', key: 'amount' },
		{ label: 'Transaction Status', key: 'status' },
	];

	const pdfDownload = (data) => {
		const tableHeader = [
			{
				mobile: 'Mobile No.',
				refTransactionId: 'Reference Transaction Id',
				transactionId: 'Transaction Id',
				createdDate: 'Transaction Date',
				amount: 'TransactionId Amount',
				status: 'Transaction Status',
			},
		];

		pdfData(data, tableHeader, 'Transaction History', 400);
	};

	const ckeckStatus = (txnId) => {
		setLoading(true);
		bbpsCheckTransactionStatus(txnId).then((resp) => {
			setLoading(false);
						if (resp?.success) {
							if (resp?.data?.status?.toUpperCase() === 'SUCCESS') {
								const msg = 'Your payment was successful! Thank you for choosing our service.';
								setAlert({ type: 'success', msg: msg});
								getTransactionHistory('');
							} else {
								setAlert({ type: 'error', msg: resp?.data.response.responseReason });
							}
						} else {
						
							if (resp?.errorCodeList.length > 0 && !isEmpty(resp?.errorCodeList[0])) {
								setAlert({ type: 'error', msg: resp?.errorCodeList[0] });
							} else {
								setAlert({ type: 'error', msg: resp?.msg });
							}
						}
		});
	};

	const closePop = () => {
	
		setTransactionDaital({});
	};

	const changePage = (page) => {
		setFilter({ ...filter, pageNo: page });
		getTransactionHistory('pagination', page);
	};
useEffect(() =>{
			
			clickOutside(transactionDaital)
		},[transactionDaital])
		
	return (
		<div className='container'>
            	<ServiceBoxWrapper className='bbps'>
							<div className="header flex justify-between items-center">
							<Back url="/" />
								<h2 className="m0">BBPS Transaction History </h2>
								<div className="logo">
									<img src={bbpsLogo2} alt="bbps logo" />
								</div>
							</div>
							<div className="service-box-body">
							<div className="flex">
					<div className="personal-information transaction">
                    <FilterWrapper className="flex items-center justify-between">
							<div className="filterBox">
								<div className="filter-text">Filter By</div>

								{/* <div className='input-field'>
								<input type="text" name="mobile" placeholder='Mobile No' value={filter.mobile} onChange={filterChangeHandler} maxLength={10} />
							</div> */}
								<div className="input-field">
									<input type="text" name="refId" placeholder="B-Connect Txn ID" value={filter.refId} onChange={filterChangeHandler} />
								</div>
								<div className="input-field">
									<input type="text" name="txnId" placeholder="Transaction Id" value={filter.txnId} onChange={filterChangeHandler} />
								</div>
								<div className="input-field">
									<select placeholder="Transaction Type" value={filter?.status} name="status" onChange={filterChangeHandler}>
										<option selected value={''}>
											Transaction status
										</option>
										<option value={'SUCCESS'}>Success</option>
										<option value={'FAIL'}>Fail</option>
										<option value={'PENDING'}>Pending</option>
									</select>
								</div>

								<div className="input-field date-filter">
									<span style={{ fontWeight: '600', marginLeft: '8px' }}>From</span>
									<input type="date" placeholder="DD-MM-YYYY" name="fromDate" value={filter.fromDate} onChange={filterChangeHandler} />
									<span style={{ fontWeight: '600' }}>To</span>
									<input
										type="date"
										placeholder="DD-MM-YYYY"
										name="toDate"
										value={filter.toDate}
										min={filter.fromDate}
										onChange={filterChangeHandler}
										disabled={isEmpty(filter.fromDate)}
									/>
								</div>
								<div className="input-field filter-Button flex gap-10">
									<button className="filterButton" onClick={() => getTransactionHistory('filter')}>
										GO
									</button>
									
									<button className="filterButton" onClick={() => getTransactionHistory('refresh')}>
									<i class="fa-solid fa-arrows-rotate"></i>
									</button>
									
									<CSVLink ref={link} data={csvData} headers={headers} filename={'Transaction-History.csv'}></CSVLink>
								</div>
							</div>
						</FilterWrapper>

						<TableWrapper className="mt20 table-card-wrapper">
							{loading && <LocalLoader className="tableLoader" />}
                            <table className="table">
								<thead className="table-head">
									<tr>
										<th>Sr. No</th>
										<th>Biller Name</th>
										<th>Service Type</th>
										<th>Transaction Id</th>
										<th>B-Connect Txn ID</th>
										<th>Transaction Date</th>
										<th>Transaction Amount</th>
										
										<th>CCF</th>
										<th>Transaction Status</th>
										<th>Raise complaint</th>
										<th>View Invoic</th>
										<th>Check Status</th>
										{/* <th>Check Status</th> */}
									</tr>
								</thead>
								<tbody className="table-body">
									{complaintHistory &&
										complaintHistory.map((data, i) => {
										
											let status = '';
											if (data?.status.toUpperCase() === 'FAIL') {
												status = 'red';
											} else if (data?.status.toUpperCase() === 'SUCCESS') {
												status = 'green';
											} else {
												status = '#adad08';
											}
											return (
												<tr key={i}>
													<td>
														<span className="card-th">Sr. No</span>
														<span>{filter.pageSize * filter.pageNo + (i + 1)}</span>
													</td>
													<td style={{maxWidth:"250px",overflow:"hidden", textOverflow:"ellipsis"}} title={data?.billerName || "-"}>
														<span className="card-th">Biller Name</span>
														<span className='text-center'>{data?.billerName || "-"}</span>
													</td>
													<td >
														<span className="card-th">Service Type</span>
														<span>{data?.category ?? '-'}</span>
													</td>
													<td className='text-center'>
														<span className="card-th">Transaction Id</span>
														<span className='text-center'>{data?.transactionId || '-'}</span>
													</td>
													<td className='text-center'>
														<span className="card-th">B-Connect Txn ID</span>
														<span className='text-center'>{data?.refTransactionId || '-'}</span>
													</td>
													
													<td className='text-center'>
														<span className="card-th">Transaction Date</span>
														<span>{data?.createdDate?getCurrentDate("",data?.createdDate,true): '-'}</span>
													</td>
													<td >
														<span className="card-th">Transaction Amount</span>
														<span>₹ {data?.amount ?? '-'}</span>
													</td>
													<td >
														<span className="card-th">CCF</span>
														<span>₹ {data?.ccf }</span>
													</td>
													<td className='text-center'>
														<span className="card-th">Transaction Status</span>
														<span style={{ color: status }}>{data?.status || '-'}</span>
													</td>
													<td>
														<span className="card-th">Raise complaint</span>
														{status !== 'red' ? (
															<button className="viewButton" onClick={() => navigate('/raise-complaint', { state: { state: data } })}>
																<i class="fa-solid fa-file-circle-exclamation"></i><span>Complaint</span>
															</button>
														) : (
															<span>-</span>
														)}
													</td>

													<td>
														<span className="card-th">View Invoic</span>
														<button className="viewButton" onClick={() => setTransactionDaital(data)}>
														<i class="fa-solid fa-eye"></i><span>View</span>
														</button>
													</td>
													<td>
														<span className="card-th">Check Status</span>
														{data?.status.toUpperCase() !== 'SUCCESS' && data?.status.toUpperCase() !== 'FAIL' ? (
															<button className="viewButton" onClick={() => ckeckStatus(data?.transactionId )}>
																<i class="fa-solid fa-list-check"></i><span>Status</span>
															</button>
														) : (
															<span>-</span>
														)}
													</td>
												</tr>
											);
										})}

									{isEmpty(complaintHistory) && !loading && (
										<tr>
											<td colSpan={'100%'} className="text-center">
												NO record found
											</td>
										</tr>
									)}
								</tbody>
							</table>
						</TableWrapper>
						{paging_data && paging_data?.totalPages > 1 && (
							<Pagination currentPage={paging_data?.number} totalPages={paging_data?.totalPages} getCurrentPageData={(page) => changePage(page)} />
						)}
					</div>
				</div>
							</div>
				
			</ServiceBoxWrapper>
			
			{!isEmpty(transactionDaital) && <BbpsTransactionReceipt bankDataResp={transactionDaital} closePop={closePop}  />}
			
		</div>
	);
};
export default BbpsTransactionHistory;